module.exports = __webpack_public_path__ + "static/media/07.025a7905.jpg";